import { ReactNode, useCallback, useMemo, useState } from "react";
import { SysMessagesContext } from "./context";
import { SysMessagesType, SysMessageWithLevel } from "./type";

const { Provider } = SysMessagesContext;

export const SysMessagesProvider = (props: {
  children: ReactNode;
}): JSX.Element => {
  const [systemMessages, setSystemMessages] = useState<SysMessageWithLevel[]>(
    []
  );

  const removeSystemMessage = useCallback((i: number) => {
    setSystemMessages((m) => {
      if (i < 0 || i >= m.length) return m;
      return [...m.slice(0, i), ...m.slice(i + 1)];
    });
  }, []);

  const addSystemMessage = useCallback(
    (m: SysMessageWithLevel) => {
      let removedIndex = -1;
      setSystemMessages((s) => {
        removedIndex = s.length;
        return [...s, m];
      });
      return () => removeSystemMessage(removedIndex);
    },
    [removeSystemMessage]
  );

  const value: SysMessagesType = useMemo(
    () => ({
      systemMessages,
      addSystemMessage,
      removeSystemMessage,
    }),
    [systemMessages, addSystemMessage, removeSystemMessage]
  );

  return <Provider value={value}>{props.children}</Provider>;
};
